/* Hero Scroll-Scrub (A案) — シンプル版 JOEKR用JS。video autoplay loop + loader fade. */
(() => {
  const hero = document.querySelector('.jhero--scrub');
  if (!hero) return;

  const video    = hero.querySelector('.jhero__video');
  const quote    = hero.querySelector('.jhero__quote');
  const sig      = hero.querySelector('.jhero__sig');
  const thumb    = hero.querySelector('.jhero__thumb');
  const subhead  = hero.querySelector('.jhero__subhead');
  const loader   = hero.querySelector('.jhero__loader');

  if (video) {
    video.muted = true;
    video.loop = true;
    video.autoplay = true;
    video.play().catch(() => {});
  }

  const LOAD_HOLD = 800;
  const LOAD_DUR  = 800;
  setTimeout(() => {
    if (loader) {
      loader.style.transition = `opacity ${LOAD_DUR}ms ease`;
      loader.style.opacity = '0';
      setTimeout(() => loader.style.display = 'none', LOAD_DUR + 50);
    }
    [quote, sig, thumb, subhead].forEach(el => {
      if (!el) return;
      el.style.transition = 'opacity 1s ease';
      el.style.opacity = '1';
    });
  }, LOAD_HOLD);

  [quote, sig, thumb, subhead].forEach(el => el && (el.style.opacity = '0'));
})();
